import React, { FC } from 'react';
import styled from 'styled-components';
import { THEME_TYPE } from 'interfaces';
import { useT } from '@hooks';

interface Props {
	marginTop?: string;
}

const Text = styled.p<Props>`
	margin-top: ${({ marginTop }) => marginTop ?? '20px'};
	text-align: center;
	font-size: 13px;
	font-weight: 400;
	color: #878e95;

	a {
		text-decoration: underline;
		color: ${({ theme }) => (theme.type === THEME_TYPE.DARK ? '#fff' : '#212121')};
	}
`;

export const PolicyText: FC<Props> = ({ marginTop }) => {
	const { T } = useT();
	return <Text marginTop={marginTop} dangerouslySetInnerHTML={{ __html: T('policyText') }} />;
};
